import angular from "angular";

angular
    .module('app')
    .component('homePage', {
        template: require('./home-page.html'),
        controller: ['$http', 'ErrorResponseParser', 'Notifier', '$sce', controller],
        bindings: {
            categories: '<',
            appName: '@',
        }
    });

function controller($http, ErrorResponseParser, Notifier, $sce) {

    let $ctrl = this;

    $ctrl.page = 1;
    $ctrl.perPage = 9;
    $ctrl.category = null;
    $ctrl.uniqCoursesCount = 0;
    $ctrl.uniqCoursesTotal = 0;
    $ctrl.courses = [];

    $ctrl.$onInit = function () {
        $ctrl.getCourses();

    };

    $ctrl.getCourses = function () {
        $ctrl.loading = true;
        $http
            .get('/get-courses-list', {
                params: {
                    page: $ctrl.page,
                    per_page: $ctrl.perPage,
                    category_id: $ctrl.category ? $ctrl.category.id : null
                }
            })
            .then(
                function (response) {
                    $ctrl.loading = false;
                    $ctrl.total = response.data.total;

                    let courses = response.data.data;
                    console.log(courses);
                    courses.forEach(function (course) {
                        console.log(course.test);
                        course.v = $sce.trustAsHtml(course.test);
                        $ctrl.courses.push(course);
                    })
                },
                function () {
                    $ctrl.loading = false;
                }
            );
    };

    $ctrl.selectCategory = function (category) {
        $ctrl.page = 1;
        $ctrl.category = category;
        $ctrl.courses = [];
        $ctrl.uniqCoursesCount = 0;
        $ctrl.uniqCoursesTotal = 0;
        $ctrl.getCourses();
    };

    $ctrl.loadMore = function () {
        $ctrl.page++;
        $ctrl.getCourses();
    };

}
